module.exports = __webpack_public_path__ + "static/media/cloudy-sun.109368f6.svg";